import { render, staticRenderFns } from "./AmendmentNotFound.vue?vue&type=template&id=66876c42&scoped=true&"
import script from "./AmendmentNotFound.vue?vue&type=script&lang=ts&"
export * from "./AmendmentNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./AmendmentNotFound.vue?vue&type=style&index=0&id=66876c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66876c42",
  null
  
)

export default component.exports